/**
 * Utility to apply custom scrollbar styling to tables when the component mounts
 */
export const enhanceTableScrolling = (): void => {
  // Target all table containers with overflow-x-auto
  const tableContainers = document.querySelectorAll('.overflow-x-auto');
  
  // Add our custom class to each container
  tableContainers.forEach(container => {
    container.classList.add('custom-table-container');
    
    // Find the closest parent that might contain the table with shadow
    const tableWrapper = container.querySelector('.shadow, .ring-1');
    if (tableWrapper) {
      tableWrapper.classList.add('table-enhanced');
    }
    
    // Make table headers sticky if they aren't already
    const tableHeader = container.querySelector('thead');
    if (tableHeader) {
      tableHeader.style.position = 'sticky';
      tableHeader.style.top = '0';
      tableHeader.style.zIndex = '10';
      tableHeader.style.backgroundColor = '#f9fafb';
      
      // Add shadow to th elements
      const headerCells = tableHeader.querySelectorAll('th');
      headerCells.forEach(cell => {
        cell.style.boxShadow = '0 1px 0 0 rgba(0, 0, 0, 0.1)';
      });
    }
  });
  
  // Add hover transitions to table rows
  const tableRows = document.querySelectorAll('tr:not(thead tr)');
  tableRows.forEach(row => {
    if (!row.classList.contains('transition-colors')) {
      row.classList.add('transition-colors', 'duration-150', 'ease-in-out');
    }
  });
}; 